import classes from "./Arbeiten.module.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import MusicProjectModal from "../CreativeEditing/MusicProjectModal";

export const Arbeiten = ({ creative }) => {
  const navigate = useNavigate();
  const [selectedMusicProject, setSelectedMusicProject] = useState(null);
  const [isMusicModalOpen, setIsMusicModalOpen] = useState(false);

  const isVisual = creative?.creativeType === "VISUAL";
  const projects = creative?.projects?.items || [];

  // Helper to get thumbnail for visual projects (handles YouTube/Vimeo and uploaded videos with thumbnails)
  const getProjectThumbnailUrl = (project) => {
    if (!project) return null;

    const firstImage = project.images?.[0];
    const firstProcessedImage = project.processedImages?.[0];

    if (firstImage && typeof firstImage === "object") {
      const urlToCheck = firstImage.url || "";
      const isLink =
        firstImage.type === "link" ||
        (urlToCheck &&
          typeof urlToCheck === "string" &&
          (urlToCheck.includes("youtube.com") ||
            urlToCheck.includes("youtu.be") ||
            urlToCheck.includes("vimeo.com")));

      const isVideoFile =
        urlToCheck &&
        typeof urlToCheck === "string" &&
        /\.(mp4|mov|avi|wmv|flv|webm|mkv|m4v)$/i.test(urlToCheck);

      // YouTube/Vimeo → use original thumbnailUrl (old behavior)
      if (isLink && firstImage.thumbnailUrl) {
        return firstImage.thumbnailUrl;
      }

      // Uploaded video with thumbnail → prefer processedThumbnailUrl, then thumbnailUrl
      if (isVideoFile) {
        if (
          firstProcessedImage &&
          typeof firstProcessedImage === "object" &&
          firstProcessedImage.processedThumbnailUrl
        ) {
          return firstProcessedImage.processedThumbnailUrl;
        }
        if (firstImage.thumbnailUrl) {
          return firstImage.thumbnailUrl;
        }
      }
    }

    // Fallback for regular images
    if (typeof firstProcessedImage === "string") {
      return firstProcessedImage;
    }

    return (
      firstProcessedImage?.processedUrl ||
      firstProcessedImage?.url ||
      firstImage?.url ||
      null
    );
  };

  const handleVisualProjectClick = (project) => {
    if (!creative?.id || !project?.id) return;
    navigate(`/members/${creative.id}/project/${project.id}/overview`);
  };

  const handleSongClick = (project) => {
    setSelectedMusicProject(project);
    setIsMusicModalOpen(true);
  };

  const handleClosePopUp = () => {
    setIsMusicModalOpen(false);
    setSelectedMusicProject(null);
  };

  return (
    <div className={classes.arbeitenContainer}>
      <h1 className="titleSemibold3">Arbeiten</h1>
      {isVisual ? (
        <div className={classes.arbeitenContent}>
          {projects?.map((project) => {
            const thumbnailUrl = getProjectThumbnailUrl(project);
            return (
              <div
                className={classes.arbeitenItemContainer}
                key={project.id}
                onClick={() => handleVisualProjectClick(project)}
              >
                <div className={classes.arbeitenItem}>
                  {thumbnailUrl && (
                    <img src={thumbnailUrl} alt={project.title} />
                  )}
                </div>
                <div className={classes.arbeitenItemText}>
                  <p style={{ color: "var(--black)" }} className="regularXs">
                    {project.title}
                  </p>
                  <p
                    style={{ color: "#8A8A91" }}
                    className="slimRegularMiniText"
                  >
                    {creative?.user?.firstName} {creative?.user?.lastName}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className={classes.musicianContent}>
          {projects?.map((project) => {
            const audioData = project.audios?.[0];
            const coverImage =
              audioData?.processedCoverImage ||
              audioData?.coverImage ||
              project.images?.[0]?.url ||
              project.processedImages?.[0]?.processedUrl;
            const album = audioData?.album || "";
            const durationMs = audioData?.durationMs;
            const duration = durationMs
              ? `${Math.floor(durationMs / 60000)}:${String(
                  Math.floor((durationMs % 60000) / 1000)
                ).padStart(2, "0")}`
              : "";

            return (
              <div
                className={classes.musicianItemContainer}
                key={project.id}
                onClick={() => handleSongClick(project)}
              >
                <div className={classes.musicianImage}>
                  {coverImage && <img src={coverImage} alt={project.title} />}
                </div>
                <div className={classes.musicianTextContainer}>
                  <div className={classes.musicianTitleContainer}>
                    <p className="titleSemibold3">{project.title}</p>
                    {album && (
                      <p
                        style={{ color: "var(--dark-grey-3)" }}
                        className="regularMiddle"
                      >
                        {album}
                      </p>
                    )}
                  </div>
                  {duration && (
                    <div className={classes.musicianDurationContainer}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="9"
                        viewBox="0 0 8 9"
                        fill="none"
                      >
                        <path
                          d="M7.63636 3.87119C8.12121 4.15066 8.12121 4.84934 7.63636 5.12881L1.09091 8.90164C0.60606 9.18111 0 8.83177 0 8.27283L0 0.727165C0 0.168226 0.606061 -0.18111 1.09091 0.0983596L7.63636 3.87119Z"
                          fill="#1F1F1F"
                        />
                      </svg>
                      <p className="regularMiddle">{duration}</p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {creative?.creativeType === "MUSIC" && (
        <MusicProjectModal
          open={isMusicModalOpen}
          onClose={handleClosePopUp}
          project={selectedMusicProject}
          creative={creative}
          projectsArray={projects}
          fromMemberPage={true}
        />
      )}
    </div>
  );
};

export default Arbeiten;